import { getChunks, getChunksBatch, clearEvents, clearChunks, getEventsBatch } from "../indexedDB/replayDB";
import api from "../services/api";
import { isWifi } from "../utils/mxutils/verificarTipoConexao";

export async function syncReplay() {
    try {
        const BATCH_SIZE = 50;

        if (!(await isWifi())) return;

        let events = await getEventsBatch(BATCH_SIZE);

        if (!events.length) return;

        events = events.map(element => {
            return {
                ...element,
                data: btoa(element.data)
            }
        });

        const response = await fetch(process.env.REACT_APP_COLETOR_IMAGEM+'/api/coletorimagem/SaveReplay', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(events),
        });

        if (response.ok) {
            const ids = events.map(e => e.id);

            await clearEvents(ids);
        }
    } catch (err) {
        console.log(err);
    }
}

export async function getReplay(request) {

    let response;

    response = await api.post("ColetorImagem/api/coletorimagem/GetReplay", request);

    return response;
}

export async function clearLocalReplay() {
    await clearChunks();
}